export const getAgeOnDate = (
  dob: string | number | Date,
  onDate: string | number | Date
) => {
  const birthDate = new Date(dob);
  const date = new Date(onDate); //Will be today's date by default
  const wholeYears = date.getFullYear() - birthDate.getFullYear();

  // if it hasn't been their birthday yet this year subtract one year from the number.
  if (date.getMonth() < birthDate.getMonth()) {
    return wholeYears - 1;
  }
  if (
    date.getMonth() === birthDate.getMonth() &&
    date.getDay() < birthDate.getDay()
  ) {
    return wholeYears - 1;
  }
  return wholeYears;
};

export default getAgeOnDate;
